import { bindActionCreators } from '@reduxjs/toolkit';
import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getThumbnail } from '../../actions/vimeo';
import { getEmbededThumbnail, getEmbededThumbnailSafe } from '../../selectors/gallery';
import { MediaButton } from '../media-button';
import { getVimeoId } from '../video-player/video-util';

import { cdn } from '../../helpers/urls';
import type { RootState } from '../../reducers';
import { getStyle } from './helper';

interface EmbedPreviewProps {
  url: string;
  imageAlt?: string;
  proportions: number;
  onDisplayMediaInModal: (url: string) => void;
}

const EmbedPreview = ({ url, imageAlt, proportions, onDisplayMediaInModal }: EmbedPreviewProps) => {
  const dispatch = useDispatch();

  const thumbnail = useSelector<RootState, string | undefined | null>((s) =>
    getEmbededThumbnail(s, { url }),
  );
  const thumbnailSafe = useSelector<RootState, string | undefined | null>((s) =>
    getEmbededThumbnailSafe(s, { url }),
  );

  const actions = bindActionCreators(
    {
      getThumbnail,
    },
    dispatch,
  );

  const timesLoadedRef = useRef(0);
  const timesFailedRef = useRef(0);

  useEffect(() => {
    vimeoThumbnailAction();
  }, [thumbnail, thumbnailSafe, url]);

  const vimeoThumbnailAction = () => {
    if (url.includes('vimeo')) {
      const id = getVimeoId(url);
      if (id && !thumbnail) {
        actions.getThumbnail(id);
      }
    }
  };

  const onImageError = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    timesFailedRef.current = timesFailedRef.current + 1;
    if (
      timesLoadedRef.current < 3 &&
      timesFailedRef.current < 3 &&
      thumbnailSafe &&
      e.currentTarget.src.localeCompare(thumbnailSafe) !== 0
    ) {
      e.currentTarget.src = thumbnailSafe;
    } else {
      e.currentTarget.src = cdn('/images/placeholders/placeholder_product_card.jpg');
    }
  };

  const onImageLoad = (e: React.SyntheticEvent<HTMLImageElement, Event>) => {
    timesLoadedRef.current = timesLoadedRef.current + 1;
    if (timesLoadedRef.current < 3) {
      if (
        e &&
        e.currentTarget &&
        e.currentTarget.naturalHeight === 90 &&
        e.currentTarget.naturalWidth === 120
      ) {
        e.persist();
        onImageError(e);
      }
    }
  };

  if (url.toLowerCase().endsWith('.mp4')) {
    return (
      <div className="slick-slide-item">
        <div className="slick-slide-video-container" style={getStyle(proportions)}>
          <video src={url} preload="metadata" className="slick-slide-video" />
          <MediaButton text="Spela Video" onClick={() => onDisplayMediaInModal(url)} icon="play" />
        </div>
      </div>
    );
  }

  return (
    <div className="slick-slide-item">
      <div className="slick-slide-image-container" style={getStyle(proportions)}>
        <img
          src={thumbnail || undefined}
          onError={onImageError}
          onLoad={onImageLoad}
          alt={imageAlt}
          onClick={() => onDisplayMediaInModal(url)}
          className="slick-slide-image"
          style={{ backgroundColor: '#000' }}
        />
        <MediaButton text="Spela Video" onClick={() => onDisplayMediaInModal(url)} icon="play" />
      </div>
    </div>
  );
};

export default EmbedPreview;
